import type { ShipFromPreferenceItemInput } from "@/graphql/codegen/graphql"

export const EMPTY_SHIP_FROM_ROW: ShipFromPreferenceItemInput = {
  shipFromWarehouseId: "",
  estimatedTransitDays: null,
  isPreferred: false,
}
